import { lazy, Suspense } from "react";
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import NotFound from "@/pages/NotFound";
import { Route, Switch } from "wouter";
import ErrorBoundary from "./components/ErrorBoundary";
import { ThemeProvider } from "./contexts/ThemeContext";
import Home from "@/pages/Home";
import { NewsPage, ArticlePage, ClubPage, DailyArchivePage, HighlightsPage, MatchesPage, StandingsPage } from "@/pages/SectionPage";
import { SeoHead } from "@/components/SeoHead";
import SiteAlerts from "./components/SiteAlerts";
import PushEngageLoader from "@/components/PushEngageLoader";
import Al5smLoader from "@/components/Al5smLoader";
import N6wxmLoader from "@/components/N6wxmLoader";
import Nap5kLoader from "@/components/Nap5kLoader";

const CMS = lazy(() => import("@/pages/CMS"));
const PrivacyPolicy = lazy(() => import("@/pages/PrivacyPolicy"));
const ContactPage = lazy(() => import("@/pages/LegalPages").then((module) => ({ default: module.ContactPage })));
const TermsPage = lazy(() => import("@/pages/LegalPages").then((module) => ({ default: module.TermsPage })));

function RouteFallback() {
  return <div className="container flex min-h-[40vh] items-center justify-center py-12 text-sm text-slate-300" role="status" aria-live="polite">جارٍ تحميل الصفحة...</div>;
}

function Router() {
  return <Suspense fallback={<RouteFallback />}><Switch><Route path="/" component={Home} /><Route path="/news" component={NewsPage} /><Route path="/article/:id" component={ArticlePage} /><Route path="/clubs/ahly" component={() => <ClubPage club="الأهلي" />} /><Route path="/clubs/zamalek" component={() => <ClubPage club="الزمالك" />} /><Route path="/highlights" component={HighlightsPage} /><Route path="/archive/:date" component={DailyArchivePage} /><Route path="/archive" component={DailyArchivePage} /><Route path="/matches/archive/:date" component={MatchesPage} /><Route path="/matches/archive" component={MatchesPage} /><Route path="/matches" component={MatchesPage} /><Route path="/standings" component={StandingsPage} /><Route path="/cms" component={CMS} /><Route path="/privacy" component={PrivacyPolicy} /><Route path="/contact" component={ContactPage} /><Route path="/terms" component={TermsPage} /><Route path="/404" component={NotFound} /><Route component={NotFound} /></Switch></Suspense>;
}

export default function App() {
  return <ErrorBoundary><ThemeProvider defaultTheme="dark"><TooltipProvider><Toaster /><SeoHead /><PushEngageLoader /><Al5smLoader /><N6wxmLoader /><Nap5kLoader /><SiteAlerts /><Router /></TooltipProvider></ThemeProvider></ErrorBoundary>;
}
